import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isLoginRequest = request.url.includes('login') || request.url.includes('oauth/token');

    if (!isLoginRequest) {
      const tokenString = localStorage.getItem('vendorClientUser_data');

      if (tokenString) {
        try {
          const tokenObj = JSON.parse(tokenString);
          const token = tokenObj?.access_token;

          if (token) {
            request = this.addToken(request, token);
          }
        } catch (error) {
          console.error('Failed to parse token from localStorage:', error);
        }
      }
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          this.logOutUser();
        }
        return throwError(() => error);
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private logOutUser(): void {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
